import { render, staticRenderFns } from "./component.vue?vue&type=template&id=f5ae3410&scoped=true"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"
import style0 from "./component.vue?vue&type=style&index=0&id=f5ae3410&prod&lang=stylus&scoped=true"
import style1 from "./component.vue?vue&type=style&index=1&id=f5ae3410&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ae3410",
  null
  
)

export default component.exports